import { createStore } from "redux";
import { generateReducers } from "automate-redux";

// Initial state of redux
const initialState = {
  fetchPosts: true,
  fetchComments: {},
  profilePicNumber:0,
  pendingRequests: 0
};

// Generate reducers with the initial state and pass it to the redux store
// if (typeof window === "undefined")
  export default createStore(generateReducers(initialState), typeof window !== "undefined" ?  window.__REDUX_DEVTOOLS_EXTENSION__ : '' && typeof window !== "undefined" ? window.__REDUX_DEVTOOLS_EXTENSION__() : '');